import React from 'react';
import { Button } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

const GridToolbarRefreshButton = ({ onClick, loading }) => {
  return (
    <Button onClick={onClick} aria-label="refresh" variant="outlined" size="small" startIcon={<RefreshIcon />} loading={loading} />
  );
};

export default GridToolbarRefreshButton;
